import { GridOptions } from 'ag-grid-community';

export abstract class XpoBaseFeature {
  gridOptions: any;
  abstract defaultGridOptions: GridOptions;
  abstract defaultGridEvents: GridOptions;
}
